import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from 'common/components/Button';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

const KsefDialog: React.FC<Props> = ({ open, onConfirm, onCancel }) => (
    <Dialog
        open={open}
        onClose={onCancel}
        PaperProps={{
            style: { width: '620px', maxWidth: '620px' }
        }}
    >
        <DialogContent>
            <DialogContentText style={{ textAlign: "center" }}>
                Nie podano numeru NIP ani identyfikatora (IDWew). <br/>
                Upewnij się, że Twoja jednostka rzeczywiście nie posiada tych danych. <br/>
                Kontynuując, potwierdzasz poprawność informacji zawartych w zamówieniu.
            </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: "flex", justifyContent: "space-between" }}>
            <Button colorTheme="darkgray" onClick={onCancel} type="button">
                Anuluj
            </Button>
            <Button onClick={onConfirm} type="button">
                Dalej
            </Button>
        </DialogActions>
    </Dialog>
);

export default KsefDialog;
